import { CloudDownload } from "@mui/icons-material";
import { useSelector } from "@xstate/react";
import { useRouter } from "next/router";
import { useMemo } from "react";

import { Tooltip } from "@moment/design-system/Tooltip";

import { useAuth } from "~/auth/useAuth";
import { useRouteParams } from "~/data/route";
import { useDocumentActor } from "~/state";
import { Button } from "~/ui/Button";

export const CloneButton = () => {
	const router = useRouter();
	const { isAuthenticated } = useAuth();
	const { documentId } = useRouteParams();

	const documentActor = useDocumentActor(documentId);
	const document = useSelector(documentActor, (state) => state);
	const isCloningRepo = document?.matches("cloning") ?? false;

	const tooltip = useMemo(() => {
		if (!isAuthenticated) {
			return "Login to clone this document";
		}
	}, [isAuthenticated]);

	const handleClone = async () => {
		documentActor?.send({
			type: "document.clone",
		});

		await router.push(`/d/local/${documentId}`);
	};

	return (
		<Tooltip.Provider>
			<Tooltip.Root>
				<Tooltip.Trigger asChild>
					<div>
						<Button
							preset="primary"
							size="sm"
							startIcon={<CloudDownload />}
							borderRadius="default"
							onClick={handleClone}
							loading={isCloningRepo}
							disabled={!isAuthenticated}
						>
							Clone
						</Button>
					</div>
				</Tooltip.Trigger>
				<Tooltip.Content>{tooltip}</Tooltip.Content>
			</Tooltip.Root>
		</Tooltip.Provider>
	);
};
